import React, { useEffect } from "react";
import useAutoCloseSidebarOnRouteChange from "../../hooks/useAutoCloseSidebarOnRouteChange";
import Sidebar from "./sidebar";
import Header from "./Header";
import { Layout } from "antd";
import { connect, useSelector } from "dva";
import { toggleSidebarCollapsed } from "../../models/router";
import { fetch as fetchShop } from "../../models/shop1";
import { getShopsByEmail, loginAs } from "../../models/auth";
import PageSpinner from "../../components/Spinner/PageSpinner";
import { getFcmToken } from "../../utils";
import { incrementCount, update } from "../../models/profile";
import {
  messaging,
  onMessageListener,
} from "../../services/utils/firebase_config";
import notificationSound from "../../assets/sounds/notification.mp3";
import newOrderNotification from "../../assets/sounds/newOrderNotification.mp3";
import useSound from "use-sound";

const { Content } = Layout;

function DashboardLayout({
  children,
  collapsed,
  toggleCollapsed,
  getShop,
  getShops,
  changeShop,
  updateProfile,

  incrementCount,
}) {
  const user = useSelector((state) => state.auth.user);
  const shop = useSelector((state) => state.shop.data);

  const shopLoading = useSelector((state) => state.auth.loading.getShops);
  const shops = useSelector((state) => state.auth.shops);

  const [playNewOrder] = useSound(newOrderNotification);
  const [playGenral] = useSound(notificationSound);

  // Auto-close sidebar on route change for mobile
  useAutoCloseSidebarOnRouteChange(collapsed, toggleCollapsed);
  useEffect(() => {
    if (user !== null) {
      getShop(user?.shop_id);
    }
  }, [user]);

  useEffect(() => {
    if (user?.email && shops.length === 0) {
      getShops(user?.email);
    }
  }, [user]);

  useEffect(() => {
    (async (user) => {
      try {
        if ("Notification" in window) {
          const perm = await Notification.requestPermission();
          if (perm === "granted") {
            const token = await getFcmToken();

            if (
              typeof token === "string" &&
              user?.fcm_tokens &&
              !user?.fcm_tokens.includes(token)
            ) {
              updateProfile({ added_fcm_token: token }, user?.id);
            }
          }
        }
      } catch (e) {
        console.log("e: ", e);
      }
    })(user);
  }, [user]);

  useEffect(() => {
    const channel = new BroadcastChannel("notification-channel");
    channel.onmessage = (event) => {
      if (event.data.type === "increase-count") {
        incrementCount();
        if (event.data.orderStatus === "pending") {
          playNewOrder();
        } else {
          playGenral();
        }
      }
    };
    return () => {
      channel.close();
    };
  }, [playGenral, playNewOrder]);

  useEffect(() => {
    if (user) {
      const unsubscribe = onMessageListener((payload) => {
        incrementCount();
        if (payload?.data?.orderStatus === "pending") {
          playNewOrder();
        } else {
          playGenral();
        }
      });

      return () => {
        if (typeof unsubscribe === "function") {
          unsubscribe();
        }
      };
    }
  }, [user, playGenral, playNewOrder]);

  return (
    <Layout style={{ height: "100vh" }}>
      <Sidebar collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <Layout>
        <Header
          collapsed={collapsed}
          toggleCollapsed={toggleCollapsed}
          shopLoading={shopLoading}
          shops={shops}
          changeShop={changeShop}
          email={user?.email}
          shopId={shop?.id}
        />
        <Layout>
          <Content
            style={{
              position: "relative",
              paddingLeft: 32,
              paddingRight: 32,
              paddingTop: 10,
              overflow: "auto",
            }}
          >
            {!shop ? <PageSpinner /> : children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default connect(
  ({ router }) => ({
    collapsed: router.sidebarCollapsed,
  }),
  {
    toggleCollapsed: toggleSidebarCollapsed,
    getShop: fetchShop,
    getShops: getShopsByEmail,
    changeShop: loginAs,
    updateProfile: update,
    incrementCount,
  },
)(DashboardLayout);
